var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H2C0.895431 0 0 0.895432 0 2V13.8798C0 14.3855 0.191595 14.8725 0.536212 15.2426L4.3723 19.3628C4.75063 19.7692 5.28087 20 5.83608 20H6.16392C6.71913 20 7.24937 19.7692 7.6277 19.3628L11.4638 15.2426C11.8084 14.8725 12 14.3855 12 13.8798V2C12 0.89543 11.1046 0 10 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineCursor);
export default __webpack_public_path__ + "static/media/timeline-cursor.a8f2f0a754fa9110afdb7ebe3bd5661e.svg";
export { ForwardRef as ReactComponent };